import React from 'react'

import ActionSentence from './action/ActionSentence'
import BaseSentence from './BaseSentence'
import ConditionsSentences from './conditions/ConditionsSentences'

const Sentence = () => {
  return (
    <>
      <BaseSentence />
      <ConditionsSentences />
      <ActionSentence />
    </>
  )
}

export default Sentence
